package com.vamvisions.main.portfolio.domain.repository

import com.vamvisions.main.core.domain.DataError
import com.vamvisions.main.core.domain.Result
import com.vamvisions.main.core.domain.preferences.Language
import com.vamvisions.main.portfolio.domain.model.Experience

interface ExperienceRepository {
    /** Every experience entry, with its texts in [language], in the order the server returns them. */
    suspend fun get(language: Language): Result<List<Experience>, DataError.Network>
}
